import React from "react";
import { Link } from "react-router-dom";

export default function PopRefundGuarantee({ product, setCloseOnClick }) {
  return (
    <div className="fs1125 helvetica">
      <h3 className="fs125 lh2 beddobck  txtcenter w100p white">
        {product?.refundGuarantee
          ? `${product.refundGuarantee} Gün İade Garantisi`
          : "90 Gün İade Garantisi"}
      </h3>
      <p className="w100p margintop-1">Değerli Ziyaretçimiz,</p>
      <p className="w100p margintop-1">
        Satın aldığınız ürünü{" "}
        {product?.refundGuarantee ? <u>{product.refundGuarantee}</u> : "90"} gün
        içinde herhangi bir nedenle iade edebilirsiniz.
      </p>
      <p className="w100p margintop-1">
        İade işlemini Müşteri Hizmetleri sayfamız üzerinden kolayca
        yapabilirsiniz.
      </p>
      <p className="w100p margintop-1">
        <Link
          className="beddo-color"
          to="/musteri-hizmetleri"
          onClick={() => setCloseOnClick(true)}
        >
          Müşteri Hizmetleri
        </Link>
      </p>
      <div className="signature margintop-1 w50p">
        <h3>Saygılarımızla,</h3>
        <h3>Tuğba Ö.</h3>
        <h3>Müşteri Hizmetleri</h3>
        <h3>beddo™</h3>
      </div>
      <p className="fs1 margintop-1">
        <span className="bold-font">Not:</span> 90 gün iade garantisi sadece{" "}
        <span className="bold-font">beddo.com</span> sitemizden yapacağınız
        alışverişlerde geçerlidir. Trendyol vb. pazaryeri sitelerinden ya da
        medikal mağazalardan aldığınız beddo™ ürünlerinde, pazaryeri sitesinin
        ve mağazanın iade koşulları geçerli olur.
      </p>
    </div>
  );
}
